import moment from "moment";
import React from "react";
import { TCRBRecord } from "../../../../../redux/app/crb/@types";
import { TCRBA1 } from "../../../../../redux/app/crb/groups/crb-a";
import CRBTableRows from "../CRBTableRows";

type OwnProps = {
	crbRecord: TCRBRecord;
	isStrikedOff?: boolean;
};
type CRBA1PreviewProps = OwnProps;
function CRBA1Preview(props: CRBA1PreviewProps) {
	const crbRecord = props.crbRecord as TCRBA1;
	const operationDate = moment(crbRecord.selectedDate, "YYYY-MM-DD").format(
		"DD-MMM-YYYY"
	);

	function renderMain() {
		return (
			<CRBTableRows
				record={crbRecord}
				tableRows={[
					[operationDate, "A", 1, renderItem1()],
					[null, null, 2, renderItem2()],
					[null, null, "NOTE", crbRecord.remarks],
				]}
			/>
		);
	}

	function renderItem1() {
		const smtStartDate = crbRecord.item2P3.startDate;
		const smtStartTime = crbRecord.item2P3.startTime;
		const smtEndDate = crbRecord.item2P3.endDate;
		const smtEndTime = crbRecord.item2P3.endTime;

		const dateTimeLocal = `${smtStartDate}T${smtStartTime}:00${crbRecord.timeZone}`;
		const utcTime = moment.utc(dateTimeLocal);
		if (crbRecord.item1.placeOfBallast.place === "AT_SEA") {
			return (
				<>
					<>
						Start - {utcTime.format("HH:mm")} hrs (UTC) ({smtStartTime} SMT) on{" "}
						{moment(smtStartDate, "YYYY-MM-DD").format("DD-MMM-YYYY")} at Lat{" "}
						{crbRecord.item1.placeOfBallast.startPosition.latitude} / Long{" "}
						{crbRecord.item1.placeOfBallast.startPosition.longitude}
					</>
					<br />
					<>
						Completion - {utcTime.format("HH:mm")} hrs (UTC) ({smtEndTime} SMT)
						on {moment(smtEndDate, "YYYY-MM-DD").format("DD-MMM-YYYY")} at Lat{" "}
						{crbRecord.item1.placeOfBallast.startPosition.latitude} / Long{" "}
						{crbRecord.item1.placeOfBallast.startPosition.longitude}
					</>
				</>
			);
		} else if (crbRecord.item1.placeOfBallast.place === "IN_PORT") {
			return (
				<>
					<>
						Start - {utcTime.format("HH:mm")} hrs (UTC) ({smtStartTime} SMT) on{" "}
						{moment(smtStartDate, "YYYY-MM-DD").format("DD-MMM-YYYY")} at{" "}
						{crbRecord.item1.placeOfBallast.portName}
					</>
					<br />
					<>
						Completion - {utcTime.format("HH:mm")} hrs (UTC) ({smtEndTime} SMT)
						on {moment(smtEndDate, "YYYY-MM-DD").format("DD-MMM-YYYY")} at{" "}
						{crbRecord.item1.placeOfBallast.portName}
					</>
				</>
			);
		}
	}
	function renderItem2() {
		const { totalLoadedQuantityOfTanks } = crbRecord.item2P2;
		return (
			<>
				<table className="min-w-full table-auto border-collapse">
					<thead className="bg-gray-600">
						<tr>
							<th className="px-4 py-2 border text-center">Tank Code</th>
							<th className="px-4 py-2 border text-center">Substance</th>
							<th className="px-4 py-2 border text-center">Category</th>
							<th className="px-4 py-2 border text-center">Quantity Loaded</th>
						</tr>
					</thead>
					<tbody>
						{crbRecord.item2.tanks.map((tank) => {
							return (
								<tr key={tank.selectedTank.id}>
									<td className="px-4 py-2 border text-center">
										{tank.selectedTank.tankCode}
									</td>
									<td className="px-4 py-2 border text-center">
										{tank.substance}
									</td>
									<td className="px-4 py-2 border text-center">
										{tank.catgeory}
									</td>
									<td className="px-4 py-2 border text-center">
										{tank.transferQuantity}
									</td>
								</tr>
							);
						})}
					</tbody>
				</table>

				<br />
				<h4 className="font-medium uppercase">
					Total Cargo Loaded: {totalLoadedQuantityOfTanks.toFixed(2)} M³
				</h4>
			</>
		);
	}

	return renderMain();
}

export default CRBA1Preview;
